var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useEffect, } from 'react';
import FilePreview from './file-preview';
import InputWrapper from './input-wrapper';
const Input = forwardRef(function Input(_a, ref) {
    var { afterLabel, children, className, helpText, hideLabel, id, label, required, errorMessage, isInvalid, inputGroupTextBefore, inputGroupTextAfter, preview } = _a, props = __rest(_a, ["afterLabel", "children", "className", "helpText", "hideLabel", "id", "label", "required", "errorMessage", "isInvalid", "inputGroupTextBefore", "inputGroupTextAfter", "preview"]);
    useEffect(() => {
        const handleWheel = (e) => {
            e.preventDefault();
        };
        if (props.type === 'number') {
            const el = document.getElementById(id);
            el === null || el === void 0 ? void 0 : el.addEventListener('wheel', handleWheel, { passive: false });
            return () => {
                el === null || el === void 0 ? void 0 : el.removeEventListener('wheel', handleWheel);
            };
        }
    }, []);
    const invalid = !!errorMessage || !!isInvalid;
    useEffect(() => {
        const el = document.getElementById(id);
        if (el) {
            el.setCustomValidity(errorMessage || '');
        }
    }, [id, errorMessage]);
    return (_jsxs(_Fragment, { children: [_jsx(InputWrapper, { afterLabel: afterLabel, className: className, required: required, label: label, id: id, helpText: helpText, hideLabel: hideLabel, children: _jsxs("div", { className: "input-group", children: [inputGroupTextBefore && (_jsx("span", { className: "input-group-text", children: inputGroupTextBefore })), _jsx("input", Object.assign({ min: props.type === 'date' ? '1900-01-01' : undefined }, props, { required: required, className: `form-control ${invalid ? 'is-invalid' : ''}`, "aria-invalid": invalid ? 'true' : 'false', id: id, ref: ref })), inputGroupTextAfter && (_jsx("div", { className: "input-group-text", children: inputGroupTextAfter })), errorMessage && (_jsx("div", { className: "invalid-feedback", children: errorMessage })), children] }) }), _jsx(FilePreview, { file: preview })] }));
});
export default Input;
